export default "__VITE_ASSET__2ae0be68__"